<template>
  <div>
    <MeetingHomeHead
      :meetingId="meetingInfo.MeetingID"
      :meetingName="meetingInfo.MeetingName"
      :meetingState="meetingInfo.State"
      :meetingStrState="meetingInfo.StrState"
      :meetingType="meetingInfo.MeetingType"
      :meetingTypeText="meetingInfo.MeetingTypeText"
      :fatherGetMeetingVoteInfo="getMeetingVoteInfo"
      :fatherRefreshHeadMeetingList="refreshHeadMeetingList"
      :fatherClickLeftNav="clickLeftNav"
      :currentNavText="currentNavText"
      v-show="!isFullScreen"
    ></MeetingHomeHead>
    <el-drawer
      title="meetingInfo.MeetingName"
      :with-header="false"
      :visible.sync="drawer"
      direction="ltr"
      size="60%"
      custom-class="drawer_left_nav_custom_class"
      :before-close="handleClose"
    >
      <el-menu
        :default-active="leftNavActiveIndex"
        @select="leftNavSelect"
        class="el-menu-vertical-demo vote_menu_box"
      >
        <el-menu-item index="1">
          <template slot="title">
            <i class="iconfont icon-zengjia"></i>
            <span>新增问卷</span>
          </template>
        </el-menu-item>
        <el-menu-item index="2">
          <template slot="title">
            <i class="iconfont icon-huaban"></i>
            <span>问卷管理</span>
          </template>
        </el-menu-item>
        <el-menu-item
          index="6"
          v-if="meetingInfo.IsVoteUserApply"
          v-show="false"
        >
          <template slot="title">
            <i class="iconfont icon-baoming"></i>
            <span>签到管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3">
          <template slot="title">
            <i class="iconfont icon-pingweiguanli"></i>
            <span>答卷人员</span>
          </template>
        </el-menu-item>
        <el-menu-item index="4">
          <template slot="title">
            <i class="iconfont icon-zu"></i>
            <span>题库管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="5">
          <template slot="title">
            <i class="iconfont icon-huizong1"></i>
            <span>结果汇总</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-drawer>
    <el-container
      id="main_container"
      class="container_meeting_home"
      :style="rowHeight"
    >
      <el-aside class="vote_left_nav hidden-sm-and-down" v-show="!isFullScreen">
        <el-menu
          :default-active="leftNavActiveIndex"
          @select="leftNavSelect"
          class="el-menu-vertical-demo vote_menu_box"
        >
          <el-menu-item index="1">
            <template slot="title">
              <i class="iconfont icon-zengjia"></i>
              <span>新增问卷</span>
            </template>
          </el-menu-item>
          <el-menu-item index="2">
            <template slot="title">
              <i class="iconfont icon-qa1"></i>
              <span>问卷管理</span>
            </template>
          </el-menu-item>
          <el-menu-item
            index="6"
            v-if="meetingInfo.IsVoteUserApply"
            v-show="false"
          >
            <template slot="title">
              <i class="iconfont icon-baoming"></i>
              <span>签到管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="3">
            <template slot="title">
              <i class="iconfont icon-pingweiguanli"></i>
              <span>答卷人员</span>
            </template>
          </el-menu-item>
          <el-menu-item index="4">
            <template slot="title">
              <i class="iconfont icon-zu"></i>
              <span>题库管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="5">
            <template slot="title">
              <i class="iconfont icon-huizong1"></i>
              <span>结果汇总</span>
            </template>
          </el-menu-item>
        </el-menu>
        <div class="vote_nav_QRCode">
          <div class="code_tip">
            二维码
            <a title="点击重新生成二维码" @click="makeCode()">
              <i class="el-icon-postcard"></i>
            </a>
            <a
              title="点击复制问卷链接"
              v-clipboard:copy="questionnaireLink"
              v-clipboard:success="cliSuccess"
              v-clipboard:error="cliEooro"
              style="margin: 0px 10px"
            >
              <i class="el-icon-copy-document"></i>
            </a>
          </div>
          <div class="code_pic" v-loading="codeLoading">
            <el-image
              :src="meetingInfo.MeetingCodeUrl"
              :preview-src-list="meetingCodeList"
              :z-index="30000"
              style="height: 150px"
            >
            </el-image>
            <span v-if="meetingInfo.State === 4">
              开始状态，通过微信扫一扫进入考试。
            </span>
            <span class="warn" v-if="meetingInfo.State !== 4">
              考试未开始
            </span>
            <span v-if="meetingInfo.State !== 4">
              请点击右上角“开始在线考试”
            </span>
          </div>
        </div>
      </el-aside>
      <el-main id="main" class="main" ref="main">
        <div class="main_top hidden-md-and-up">
          <span>
            {{ meetingInfo.MeetingName }}
          </span>
          <span v-if="meetingInfo.State === 1" class="draft_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 4" class="publish_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 3" class="end_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 6" class="close_color">
            {{ meetingInfo.StrState }}
          </span>
          <el-link
            title="编辑活动"
            :underline="false"
            @click="openMettingEdit()"
          >
            <i class="el-icon-edit-outline"></i>
          </el-link>
        </div>
        <router-view
          :questionnaireListPagingQuery="questionnaireListPagingQuery"
          :meetingInfo="meetingInfo"
          @changePaging="changePaging"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import MeetingHomeHead from '@/components/MeetingHomeHead.vue'
export default {
  name: 'wj_home',
  components: {
    MeetingHomeHead
  },
  data () {
    return {
      rowHeight: {
        height: (window.innerHeight - 56) + 'px',
        marginTop: '56px'
      },
      leftNavActiveIndex: '1',
      meetingInfo: {},
      meetingCodeList: [],
      questionnaireListPagingQuery: {
        maxResultCount: 10,
        skipCount: 0,
        currentPage: 1
      },
      codeLoading: true,
      drawer: false,
      currentNavText: null,
      isFullScreen: false,
      questionnaireLink: null
    }
  },
  provide () {
    return {
      getMeetingVoteInfo: this.getMeetingVoteInfo,
      homeSwitchFullScreen: this.homeSwitchFullScreen
    }
  },
  methods: {
    handleClose (done) {
      done()
    },
    clickLeftNav () {
      this.drawer = !this.drawer
    },
    leftNavSelect: function (key, keyPath) {
      switch (key) {
        case '1':
          this.$router.push({ name: 'createQuestionnaireBasic', params: { mid: this.$route.params.mid, qid: '0' } })
          this.currentNavText = '新增问卷'
          this.drawer = false
          break
        case '2':
          this.questionnaireListPagingQuery.skipCount = 0
          this.questionnaireListPagingQuery.maxResultCount = 10
          this.questionnaireListPagingQuery.currentPage = 1
          this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
          this.currentNavText = '问卷管理'
          this.drawer = false
          break
        case '3':
          this.$router.push({ name: 'wjUserGroup', params: { mid: this.$route.params.mid, qid: '0' } })
          this.currentNavText = '答卷人员'
          this.drawer = false
          break
        case '4':
          this.$router.push({ name: 'questionBankManage', params: { cid: this.meetingInfo.CompanyID, mid: this.$route.params.mid } })
          this.currentNavText = '题库管理'
          this.drawer = false
          break
        case '5':
          this.$router.push({ name: 'questionnaireResultsSummary', params: { mid: this.$route.params.mid } })
          this.currentNavText = '结果汇总'
          this.drawer = false
          break
        case '6':
          this.$router.push({ name: 'wjUserApplyManager', params: { mid: this.$route.params.mid } })
          this.currentNavText = '签到管理'
          this.drawer = false
          break
      }
    },
    getMeetingVoteInfo: function () {
      this.codeLoading = true
      this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: this.$route.params.mid
      }).then(data => {
        this.meetingInfo = data
        this.meetingCodeList = []
        // this.meetingCodeList.push(this.meetingInfo.MeetingWXCodeUrl)
        this.meetingCodeList.push(this.meetingInfo.MeetingCodeUrl)
        this.questionnaireLink = this.meetingInfo.QuestionnaireLink + '/' + this.meetingInfo.CompanyID + '/' + this.$route.params.mid + '/0'
        this.codeLoading = false
      }).catch(err => {
        this.codeLoading = false
        return err
      })
    },
    refreshHeadMeetingList: function () {
      this.$refs.mainHeadChild.getMeetingList()
    },
    makeCode: function () {
      this.$api.meetingManage.makeCode(this.$route.params.mid).then(data => {
        this.meetingInfo.MeetingWXCodeUrl = ''
        this.meetingInfo.MeetingCodeUrl = ''
        this.getMeetingVoteInfo()
        this.$message({
          showClose: true,
          type: 'success',
          message: '生成成功!',
          customClass: 'custom_message'
        })
      }).catch(err => {
        return err
      })
    },
    copyQuestionnaireLink: function () {
      this.questionnaireLink = this.meetingInfo.QuestionnaireLink + '/' + this.meetingInfo.CompanyID + '/' + this.$route.params.mid
    },
    changePaging: function (skipCount, maxResultCount, currentPage) {
      this.questionnaireListPagingQuery.skipCount = skipCount
      this.questionnaireListPagingQuery.maxResultCount = maxResultCount
      this.questionnaireListPagingQuery.currentPage = currentPage
    },
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    changeActiveIndex: function () {
      switch (this.$route.name) {
        case 'wjUser':
          this.leftNavActiveIndex = '3'
          this.currentNavText = '答卷人员'
          break
        case 'wjUserGroup':
          this.leftNavActiveIndex = '3'
          this.currentNavText = '答卷人员'
          break
        case 'questionBankManage':
          this.leftNavActiveIndex = '4'
          this.currentNavText = '题库管理'
          break
        case 'questionManage':
          this.leftNavActiveIndex = '4'
          this.currentNavText = '题库管理'
          break
        case 'questionnaireManage':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'createQuestionnaireBasic':
          this.leftNavActiveIndex = '1'
          this.currentNavText = '新增问卷'
          break
        case 'createQuestionnaireUser':
          this.leftNavActiveIndex = '1'
          this.currentNavText = '新增问卷'
          break
        case 'createQuestionnaireBody':
          this.leftNavActiveIndex = '1'
          this.currentNavText = '新增问卷'
          break
        case 'editQuestionnaireBasic':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'editQuestionnaireUser':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'editQuestionnaireQuestion':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'editQuestionnaireSetting':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'questionnaireDetail':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'questionnaireResult':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'questionnaireProgress':
          this.leftNavActiveIndex = '2'
          this.currentNavText = '问卷管理'
          break
        case 'questionnaireResultsSummary':
          this.leftNavActiveIndex = '5'
          this.currentNavText = '结果汇总'
          break
        case 'wj_manageBasic':
          this.currentNavText = '基本信息'
          break
        case 'wjUserApplyManager':
          this.leftNavActiveIndex = '6'
          this.currentNavText = '签到管理'
          break
      }
    },
    openMettingEdit: function () {
      this.$router.push({ name: 'wj_manageBasic', params: { mid: this.$route.params.mid } })
      this.currentNavText = '基本信息'
    },
    homeSwitchFullScreen: function () {
      const _this = this
      _this.isFullScreen = !_this.isFullScreen
      if (_this.isFullScreen) {
        _this.rowHeight = {
          height: (window.innerHeight - 26) + 'px',
          marginTop: '26px'
        }
      } else {
        _this.rowHeight = {
          height: (window.innerHeight - 56) + 'px',
          marginTop: '56px'
        }
      }
    },
    cliSuccess () {
      this.$message({
        type: 'success',
        message: '复制成功',
        customClass: 'custom_message'
      })
    },
    cliEooro () {
      this.$message({
        type: 'error',
        message: '复制失败',
        customClass: 'custom_message'
      })
    }
  },
  created () {
    this.changeActiveIndex()
    this.getMeetingVoteInfo()
  },
  watch: {
    $route () {
      this.changeActiveIndex()
      // this.getMeetingVoteInfo()
    }
  }
}
</script>
<style lang="less">
.vote_menu_box .el-menu-item {
  height: 48px;
  line-height: 48px;
}
</style>
